module.exports = __webpack_public_path__ + "img/icon1.a2ea3881.jpg";